module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/play-b145b8c282accc3766aac98fa85e5a7b.svg";